export default class Mention {
  public mention: string = '';
  public profileIcon: string = '';

  constructor({mention, profileIcon}: Mention) {
    this.mention = mention ? mention : '';
    this.profileIcon = profileIcon ? profileIcon : '';
  }
}
